import UnarchiveOutlinedIcon from '@material-ui/icons/UnarchiveOutlined'
import { Button, Chip, styled } from 'opensolar-ui'
import { useCallback } from 'react'
import { useTranslate } from 'react-admin'

const StyledChip = styled(Chip, { name: 'ShowArchivedButton' })({
  height: '46px', // 46px is the height of the button
})

const StyledButton = styled(Button, { name: 'ShowArchivedButton' })({
  marginRight: '5px',
})

const ShowArchivedButton = (props: any) => {
  const translate = useTranslate()
  const { label = 'Show Archived', filterValues, setFilters } = props
  const handleClick = useCallback(() => {
    setFilters({ ...filterValues, show_only_archived: 1 })
  }, [filterValues])
  const handleDelete = useCallback(() => {
    setFilters({ ...filterValues, show_only_archived: 0 })
  }, [filterValues])
  const showArchived = !!filterValues?.show_only_archived
  return showArchived ? (
    <StyledChip variant="outlined" size="medium" label={translate(label)} onDelete={handleDelete} />
  ) : (
    <StyledButton
      startIcon={<UnarchiveOutlinedIcon />}
      variant="outlined"
      color="default"
      size="large"
      onClick={handleClick}
    >
      <span>{translate(label)}</span>
    </StyledButton>
  )
}

export default ShowArchivedButton
